(function () {
    'use strict';

    function PasswordResetCtrl(restangular, toastr, email, token, $state, utilService) {
        var vm = this;
        
        vm.busy = false;
        vm.validationErrors = [];
        vm.userInfo = {
            email: email,
            token: token
        };

        vm.resetPassword = resetPassword;

        //////////////////////////////////////////
        function resetPassword(form) {
            if (!form.$valid || vm.busy) return;

            vm.busy = true;
            vm.validationErrors = [];
            restangular
                .one('account')
                .post('resetpassword', vm.userInfo)
                .then(function () {
                    vm.busy = false;
                    toastr.info('Your password has been successfully reset.', 'Notification');
                    $state.go('login');
                }, function (err) {
                    vm.validationErrors = utilService.parseViewModelResponse(err, utilService.errorEnum.VALIDATIONS);
                    vm.busy = false;
                });
        }
    };

    angular
        .module('app')
        .controller('PasswordResetCtrl', [
            'Restangular', 'toastr', 'email', 'token', '$state', 'utilService', PasswordResetCtrl]);

})();